import {
  Select,
  SelectItem,
  SelectList,
  SelectTrigger,
} from "@/components/ui/select";
import { useTimeframe } from "../state";

const timeframeOptions = [
  {
    label: "Last 7 days",
    value: 7,
  },
  {
    label: "Last 30 days",
    value: 30,
  },
  {
    label: "Last 3 months",
    value: 92,
  },
  {
    label: "Last 6 months",
    value: 183,
  },
  {
    label: "Last year",
    value: 365,
  },
  {
    label: "All time",
    value: 365 * 10,
  },
];

export function TimeframeSelect() {
  const { days, setDays } = useTimeframe();

  return (
    <Select
      aria-label="Timeframe"
      selectedKey={days.toString()}
      onSelectionChange={(v) => setDays(Number(v))}
    >
      <SelectTrigger className="w-40" />
      <SelectList>
        {timeframeOptions.map((opt) => (
          <SelectItem
            id={opt.value.toString()}
            key={opt.value.toString()}
            value={opt}
            textValue={opt.label}
          >
            {opt.label}
          </SelectItem>
        ))}
      </SelectList>
    </Select>
  );
}
